import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronLeft, Leaf } from "lucide-react";
import { motion } from "framer-motion";

export default function StepShell({ title, subtitle, current, total, onBack, children, footer, sessionNumber = 1, section }) {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-[var(--ha-bg)]" data-testid="step-shell">
      <header className="sticky top-0 z-10 bg-[var(--ha-bg)]/90 backdrop-blur border-b border-[var(--ha-border)]">
        <div className="max-w-4xl mx-auto px-5 sm:px-6 py-4 flex items-center gap-4">
          <button
            data-testid="step-exit-btn"
            onClick={() => navigate("/dashboard")}
            className="h-9 w-9 rounded-full border border-[var(--ha-border)] grid place-items-center bg-white hover:bg-[var(--ha-bg)] transition-colors"
            aria-label="Volver al panel"
          >
            <ArrowLeft className="w-4 h-4 text-[var(--ha-text)]" strokeWidth={1.75} />
          </button>
          <div className="flex-1">
            <div className="flex items-center justify-between text-xs text-[var(--ha-muted)] mb-1.5">
              <span className="uppercase tracking-[0.18em] font-semibold">Sesión {String(sessionNumber).padStart(2,"0")} · Paso {current} de {total}</span>
              <span>{Math.round((current/total)*100)}%</span>
            </div>
            <Progress value={(current/total)*100} className="h-1.5 bg-[var(--ha-border)]" />
          </div>
          <div className="hidden sm:flex items-center gap-1.5 text-[var(--ha-primary)]">
            <Leaf className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-xs font-semibold">MINDHOME HEALTH APP</span>
          </div>
        </div>
      </header>

      <motion.section
        key={current}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="max-w-4xl mx-auto px-5 sm:px-6 py-10 sm:py-14"
      >
        {section && (
          <div
            className="inline-flex items-center gap-2 rounded-full border border-[var(--ha-primary)]/25 bg-[var(--ha-primary)]/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-[var(--ha-primary)] mb-4"
            data-testid={`step-section-badge-${section.id}`}
          >
            <span>Apartado {section.number}/3</span>
            <span className="opacity-40">·</span>
            <span>{section.label}</span>
          </div>
        )}
        {title && <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[var(--ha-text)]">{title}</h1>}
        {subtitle && <p className="mt-3 text-[var(--ha-muted)] max-w-2xl leading-relaxed">{subtitle}</p>}
        <div className="mt-8">{children}</div>

        {footer && (
          <div className="mt-10 flex flex-wrap items-center justify-between gap-3">
            {onBack ? (
              <Button
                data-testid="step-prev-btn"
                variant="outline"
                onClick={onBack}
                className="rounded-full border-[var(--ha-border)] h-11 px-5"
              >
                <ChevronLeft className="w-4 h-4 mr-1" strokeWidth={1.75} /> Anterior
              </Button>
            ) : <div />}
            {footer}
          </div>
        )}
      </motion.section>
    </main>
  );
}
